module.exports = __webpack_public_path__ + "img/instagram_act.d028e7a3.png";